import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { checkoutStepsSelector, goToStep } from "redux/checkoutSteps";
import { UseAppDispatch } from "redux/store";
import { useNavigate } from "react-router-dom";
import { setInTransition } from "redux/transition/transition.slice";
import { selectedItinerarySelector } from "redux/selectedItinerary";

interface IMobileCheckoutHeaderProps {
  title: string;
}
export default function MobileCheckoutHeader(
  props: IMobileCheckoutHeaderProps,
) {
  const { title } = props;
  const dispatch = UseAppDispatch();
  const { currentStep, steps } = useSelector(checkoutStepsSelector);
  const { includesBrandedFares } = useSelector(selectedItinerarySelector);
  const { transitions } = useTheme();
  const navigate = useNavigate();

  const getTotalSteps = (): number => {
    const allStepsLength = Object.keys(steps).length;
    return includesBrandedFares ? allStepsLength : allStepsLength - 1;
  };

  const getCurrentStep = (): number => {
    return includesBrandedFares ? currentStep + 1 : currentStep;
  };

  const handleBackClick = () => {
    if (
      (includesBrandedFares && currentStep === 0) ||
      (!includesBrandedFares && currentStep === 1)
    ) {
      navigate(-1);
    } else {
      dispatch(setInTransition(true));

      setTimeout(() => {
        dispatch(goToStep(currentStep - 1));
        window.scrollTo(0, 0);
        dispatch(setInTransition(false));
      }, transitions.duration.standard);
    }
  };

  return (
    <>
      <IconButton sx={{ ml: -2 }} onClick={handleBackClick} color="white">
        <ChevronLeft fontSize="large" />
      </IconButton>
      <Typography
        variant="h3"
        sx={{ textTransform: "uppercase", flexGrow: "1", textAlign: "center" }}
      >
        {title}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Typography variant="h6">
          {getCurrentStep()} / {getTotalSteps()}
        </Typography>
      </Box>
    </>
  );
}
